import React from 'react'
import { Select, ValidationMessage } from '../..'
import { isEmpty } from 'lodash'
import { RulePermissionModuleSelectProps } from './types'

const RulePermissionModuleSelect: React.FC<RulePermissionModuleSelectProps> = (props) => {
    const { index, value, isMultiSelect, selectOptions, placeholder, type, handleChange, testId, errorMessage, hasBranchFeature } = props

    const handleSelectChange = (event: any) => {
        if (handleChange) {
            handleChange(event)
        }
    }

    const filterOptionFunction = (candidate, string) => {
        let lowerstring = string.toLowerCase();
        if (hasBranchFeature) return candidate.data.searchableLabel.toLowerCase().includes(lowerstring);
        return candidate.label.toString().toLowerCase().includes(lowerstring) ||
            candidate.value.toString().includes(string)
    };

    return (
        <div className="pb-10">
            <Select
                name={`selectRules_${type}_${index}`}
                value={value}
                isMulti={isMultiSelect}
                onChange={(event) => handleSelectChange(event)}
                isClearable={['module', 'module-value'].includes(type) ? false : true}
                isSearchable={true}
                options={selectOptions}
                placeholder={placeholder}
                testId={`${testId}`}
                error={isEmpty(value) && errorMessage ? true : false}
                version="v2"
                minWidth="240px"
                maxWidth="440px"
                {...(type === 'module-value' ? { filterOption: filterOptionFunction } : {})}
            />
            <ValidationMessage
                version="v2"
                style={{
                    maxWidth: '13rem'
                }}
                testId={`${testId}-input-permission-error`}>
                {errorMessage}
            </ValidationMessage>
        </div>
    )
}

export default RulePermissionModuleSelect
